import { render, staticRenderFns } from "./RLogoIcon.vue?vue&type=template&id=41b737a5&scoped=true"
import script from "./RLogoIcon.vue?vue&type=script&lang=ts"
export * from "./RLogoIcon.vue?vue&type=script&lang=ts"
import style0 from "./RLogoIcon.vue?vue&type=style&index=0&id=41b737a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b737a5",
  null
  
)

export default component.exports